<template>
    <div id="camera-section" class="web-camera-container">
        <div class="camera-button">
            <button type="button" class="btn btn-block" @click="toggleCamera" :disabled="isTimeExpired">
                <div class="d-flex mx-auto align-items-center justify-content-center">
                    <img src="@/assets/photo-camera.svg" class=" mr-2 camera-image opacity-80">
                    <span class="mt-1 d-block" v-if="!isCameraOpen"><span v-if="selfiemessage && selfiemessage!==''">{{selfiemessage}}</span> Selfie Photo <span class="text-danger">*</span></span>
                    <span class="mt-1 d-block" v-else>Close Camera</span>
                </div>
                <span class="d-block text-center selfie-subtitle">Selfie Along with Office Name Plate</span>
            </button>
        </div>
        <div v-if="isCameraOpen" class="camera-box" :class="{ 'flash' : isShotPhoto }">
            <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
            <video v-show="!isPhotoTaken" ref="camera" :width="450" :height="337.5" class="my-4" autoplay playsinline></video>
            <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" class="my-4" :width="canvasWidth" :height="canvasHeight"></canvas>
        </div>
        <div class="d-flex camera-op justify-content-center position-relative">
            <div v-if="isCameraOpen" class=" ">
                <button type="button" class="btn camera-shoot mx-auto p-2 d-flex justify-content-center align-items-center" @click="takePhoto">
                    <img src="@/assets/capture.svg" class="opacity-80">
                </button>
            </div>
            <div v-if="isCameraOpen" class="">
                <button type="button" class="btn camera-shoot camera-switch mx-auto p-2 d-flex justify-content-center align-items-center" @click="switchCamera">
                    <img src="@/assets/flip-camera.svg" class="opacity-80">
                </button>
            </div>
        </div>
        <div class="error" v-if="checkSize">
        	Please use image of less than 5MB                                            
        </div>
        <div class="error" v-if="checkPhoto">
            Field is required
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isCameraOpen: false,
            isPhotoTaken: false,
            isShotPhoto: false,
            photos: [],
            canvasWidth: 450,
            canvasHeight: 337.5,
            videoDevices: [],
            mediaStream: null,
            facingMode: "environment",
            switchingCamera: false,
            finalImage:null,
            photoSet:null,
            checkSize:false,
            checkPhoto: false,
            maxImageSize:5 * 1024 * 1000,
            isTimeExpired: false,
        }
    },
    beforeDestroy(){
    	if(this.isCameraOpen){
    		this.stopCameraStream();
    	}
    },
    props: ['selfiemessage'],
    methods: {
        async switchCamera() {
            this.switchingCamera = true;
            const tracks = this.mediaStream.getVideoTracks();
            tracks.forEach((track) => {
                track.stop();
            });
            await this.createCameraElement(
                this.facingMode === "environment" ? "user" : "environment"
            );
            this.switchingCamera = false;
        },
        async toggleCamera() {
            if (this.isCameraOpen) {
                this.isCameraOpen = false;
                this.isPhotoTaken = false;
                this.isShotPhoto = false;
                this.stopCameraStream();
            } else {
                this.isCameraOpen = true;
                const devices = await navigator.mediaDevices.enumerateDevices();
                this.videoDevices = devices.filter((d) => d.kind === "videoinput");
                await this.createCameraElement(
                    this.videoDevices.length === 1 ? "user" : "environment"
                );
                const dimensions = this.videoDimensions(this.$refs.camera);
                this.canvasWidth = dimensions.width;
                this.canvasHeight = dimensions.height;
            }
        },
        async createCameraElement(facingMode) {
            this.facingMode = facingMode;
            let video = this.$refs.camera;
            this.mediaStream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: facingMode },
            });
            video.srcObject = this.mediaStream;
            return await video.play();
        },
        stopCameraStream() {
            let tracks = this.$refs.camera.srcObject.getTracks();
            tracks.forEach(track => {
                track.stop();
            });
        },
        takePhoto() {
            if (!this.isPhotoTaken) {
                this.isShotPhoto = true;
                const FLASH_TIMEOUT = 50;
                setTimeout(() => {
                    this.isShotPhoto = false;
                }, FLASH_TIMEOUT);
            }
            this.isPhotoTaken = !this.isPhotoTaken;
            const context = this.$refs.canvas.getContext('2d');

            context.drawImage(this.$refs.camera, 0, 0, this.canvasWidth, this.canvasHeight);
            this.finalImage = this.dataURLtoFile(document.getElementById("photoTaken").toDataURL("image/jpeg"), "selfie-file");
            if(this.finalImage){
            	this.photoSet = true;
            	this.checkPhoto = false;
            }else{
            	this.photoSet = null;
            }
        },
        dataURLtoFile(dataurl, filename) {
            const arr = dataurl.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            if(n > this.maxImageSize){
            	this.checkSize = true;
            	return null;
            }else{
            	this.checkSize = false;
            }
            const u8arr = new Uint8Array(n);
            while (n) {
                u8arr[n - 1] = bstr.charCodeAt(n - 1);
                n -= 1;
            }
            return new File([u8arr], filename, { type: mime });
        },
        videoDimensions(video) {
            // Ratio of the video's intrisic dimensions
            let videoRatio = video.videoWidth / video.videoHeight;
            // The width and height of the video element
            let width = video.offsetWidth,
                height = video.offsetHeight;
            // The ratio of the element's width to its height
            let elementRatio = width / height;
            // If the video element is short and wide
            if (elementRatio > videoRatio) width = height * videoRatio;
            // It must be tall and thin, or exactly equal to the original ratio
            else height = width / videoRatio;
            return {
                width: width,
                height: height
            };
        }
    },
}
</script>
<style scoped>
.web-camera-container {
    margin-top: 1rem;
    padding: 0.8rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #dfdfe8;
    border-radius: 4px;
    width: 100%;
}

#photoTaken {
    width: 100%;
}

.camera-image {
    width: 2rem;
}

.opacity-80 {
    opacity: 0.8;
}

.selfie-subtitle {
    opacity: 0.5;
}

.camera-op {
    width: 100%;
}

.camera-shoot {
    border: 1px solid #D1D5DB;
    background: #F3F4F6;
    border-radius: 50%;
    width: 3.5rem;
    height: 3.5rem;
}

.camera-shoot-image {
    width: 3.5rem;
    height: 3.5rem;
}

.camera-switch {
    position: absolute;
    right: 0;
}

.camera-button {
    width: 100%;
}
</style>